import CommentIcon from '@images/article/comments.svg'
import LikesIcon from '@images/article/hearts.svg'

import Label from './label'

import styles from './post-comments-and-likes.module.scss'

type CommentsAndLikesProps = {
  comments: number
  likes: number
  className?: string
  isLoading?: boolean
}
export default function CommentsAndLikes({
  comments,
  likes,
  className = '',
  isLoading,
}: CommentsAndLikesProps): JSX.Element {
  return (
    <div className={`${styles.summary} ${className}`}>
      <Label count={comments} label="Comments" icon={CommentIcon} isLoading={isLoading} />
      <Label count={likes} label="Likes" icon={LikesIcon} isLoading={isLoading} />
    </div>
  )
}
